<div class="back-general flex align-items-center justify-content-center min-h-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center" style="padding: 3rem;">
        <h1>Registro de Nuevo Consorcista</h1>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="forms">
            <div class=" w-full surface-card py-8 px-5 sm:px-8 card-form">
                <legend>Paso {{stepsTaken}} <!-- de {{stepsRemaining + (extraStepType ? 1 : 0) + (extraStepCochera ? 1 : 0) + (extraStepIfCochera ? 1 : 0) }} --></legend>
                <p><br></p>
                @switch(actualStep){
                    @case('welcomeStep'){
                        <h2>¡Hola!</h2>
                        <h4>Te vamos a registrar en</h4>
                        @if(consorcio){
                            <h4><b>{{consorcio.name}}</b></h4>
                        }

                    }
                    @case('nameStep'){
                        <div formGroupName="nameStep" class="form-container">
                            <p class="overtitle">Sobre vos</p>
                            <h4> ¿Cuál es tu nombre y apellido? <br><br></h4>
                            <label for="firstName">Nombre</label>

                            <input id="firstName" formControlName="firstName" type="text" placeholder="Nombre" pInputText/>
                            <div class="errorValidation" *ngIf="form.get('nameStep.firstName')?.invalid && (form.get('nameStep.firstName')?.touched || submitted)">
                                <p> Campo obligatorio</p>
                            </div>
                            <p><br></p>

                            <label for="lastName">Apellido</label>
                            <input id="lastName" formControlName="lastName" type="text" placeholder="Apellido" pInputText/>
                            <div class="errorValidation" *ngIf="form.get('nameStep.lastName')?.invalid && (form.get('nameStep.lastName')?.touched || submitted)">
                                <p> Campo obligatorio</p>
                            </div>
                            <p><br></p>
                        </div>
                    }
                    @case('typeStep'){
                        <div formGroupName="typeStep" class="form-container">
                            <p class="overtitle">Sobre vos</p>
                            <h4 style="padding-bottom: 1rem;"> ¿Sos propietario, inquilino o representás a una inmobiliaria?</h4>
                            <p-dropdown formControlName="consorcistaType"
                                [options]="consorcistaTypeOptions"
                                placeholder="Tipo de Consorcista"
                                styleClass="w-full"
                                optionLabel="label"
                                optionValue="value"
                            />
                            <div class="errorValidation" *ngIf="form.get('typeStep.consorcistaType')?.invalid && (form.get('typeStep.consorcistaType')?.touched || submitted)">
                                    <p> Campo obligatorio</p>

                            </div>
                                <p><br></p>
                        </div>
                    }
                    @case('stepContrato'){
                        <div formGroupName="stepContrato" class="form-container">
                            <p class="overtitle">Sobre vos</p>
                            <h4 style="padding-bottom: 1rem;">¿Alquilás directo con el propietario o a través de una inmobiliaria?</h4>
                            <div class="radio-square">
                                <input id="contratoDue" class="input-number" name="contrato" [value]="'direct'" formControlName="contrato" type="radio">
                                <label for="contratoDue"> Directo con el propietario </label>
                                <input id="contratoInm" class="input-number" name="contrato" [value]="'realEstate'" formControlName="contrato" type="radio">
                                <label for="contratoInm">  A través de una inmobiliaria </label>
                            </div>
                            <div class="errorValidation" *ngIf="form.get('stepContrato.contrato')?.invalid && (form.get('stepContrato.contrato')?.touched || submitted)">
                                    <p> Campo obligatorio</p>

                            </div>
                            <p><br></p>
                        </div>
                    }
                    @case('stepRealEstate'){
                        <div formGroupName="stepRealEstate" class="form-container">
                            <p class="overtitle">Sobre vos</p>
                            <h4> ¿Cuál es el nombre de la inmobiliaria?<br><br></h4>
                            <input id="realEstateName" formControlName="realEstateName" type="text" placeholder="Nombre" pInputText/>
                            <div class="errorValidation" *ngIf="form.get('stepRealEstate.realEstateName')?.invalid && (form.get('stepRealEstate.realEstateName')?.touched || submitted)">
                                <p> Campo obligatorio</p>
                            </div>
                            <p><br></p>
                        </div>
                    }
                    @case('unitStep'){
                        <div formGroupName="unitStep" class="form-container">
                            <p class="overtitle">Seleccioná tu unidad</p>
                            <h4>Tocá una unidad en el gráfico para seleccionarla</h4>
                            <p><br></p>
                            @if(consorcio.cocheras){
                                <div class="flex gap-2 align-items-center">
                                    <input id="onlyGarage" formControlName="onlyGarage" type="checkbox"/>
                                    <label style="margin:0" for="onlyGarage">No vivo en el edificio, solo tengo/uso una cochera.</label>
                                </div>
                                <p><br></p>
                            }
                            <div [ngClass]="{'grayfilter':form.get('unitStep.onlyGarage').value}">
                                <app-consorcio-scheme [towers]="consorcio.towers" [hasTowers]="consorcio.hasTowers || false" [floors]="consorcio.floors" [floorScheme]="consorcio.floorScheme" [(selectFloor)]="selectFloor" [(selectApartment)]="selectApartment" [(selectTower)]="selectTower" (onSelectEvent)="fillUnitStepForm($event)"></app-consorcio-scheme>
                                <p><br/></p>
                                @if(consorcio.hasTowers){
                                    <label for="Tower">Torre</label>
                                    <input readonly id="tower" formControlName="tower" type="text" placeholder="Torre" pInputText/>
                                    <div class="errorValidation" *ngIf="form.get('unitStep.tower')?.invalid && (form.get('unitStep.tower')?.touched || submitted)">
                                        <p> Campo obligatorio</p>
                                    </div>
                                    <p><br></p>
                                }
                                <label for="floor">Piso</label>
                                <input readonly id="floor" formControlName="floor" type="text" placeholder="Piso" pInputText/>
                                <div class="errorValidation" *ngIf="form.get('unitStep.floor')?.invalid && (form.get('unitStep.floor')?.touched || submitted)">
                                    <p> Campo obligatorio</p>
                                </div>
                                <p><br></p>

                                <label for="unit">Departamento</label>
                                <input readonly id="unit" formControlName="unit" type="text" placeholder="Departamento" pInputText/>
                                <div class="errorValidation" *ngIf="form.get('unitStep.unit')?.invalid && (form.get('unitStep.unit')?.touched || submitted)">
                                    <p> Campo obligatorio</p>
                                </div>
                                <p><br></p>
                            </div>
                        </div>
                    }
                    @case('ifCocheraStep'){
                        <div formGroupName="cocheraStep" class="form-container">
                            <p class="overtitle">Cochera</p>
                            <h4  style="padding-bottom: 1rem;">¿Tenés cochera en el edificio?</h4>
                            <div class="radio-square">
                                <input id="cocheraTrue" class="input-number" name="hasGarage" [value]="true" formControlName="hasGarage" type="radio">
                                <label for="cocheraTrue"> Sí </label>
                                <input id="cocheraFalse" class="input-number" name="hasGarage" [value]='false' formControlName="hasGarage" type="radio">
                                <label for="cocheraFalse">  No </label>
                            </div>
                            <div class="errorValidation" *ngIf="form.get('cocheraStep.hasGarage')?.invalid && (form.get('cocheraStep.hasGarage')?.touched || submitted)">
                                    <p> Campo obligatorio</p>

                            </div>
                            <p><br></p>
                        </div>
                    }
                    @case('cocheraStep'){
                        <div formGroupName="cocheraStep" class="form-container">
                            <p class="overtitle">La unidad</p>
                            <h4>Elegí tu unidad en el gráfico </h4>
                            <app-cocheras-view [tieneNiveles]="consorcio.garageLevels??true" [cocheras]="consorcio.cocheras" [(selectedNivel)]="selectedNivel" [(selectedNumero)]="selectedNumero" (onSelect)="fillCocheraStepForm($event)"></app-cocheras-view>
                            <p><br/></p>

                            @if (consorcio.garageLevels) {
                                <label for="cocheraLevel">Nivel</label>
                                <input readonly id="cocheraLevel" formControlName="cocheraLevel" type="text" placeholder="Piso" pInputText/>
                                <div class="errorValidation" *ngIf="form.get('cocheraStep.cocheraLevel')?.invalid && (form.get('cocheraStep.cocheraLevel')?.touched || submitted)">
                                    <p> Campo obligatorio</p>
                                </div>
                                <p><br></p>
                            }
                            <label for="cocheraNumber">Cochera</label>
                            <!-- muestra la etiqueta de la cochera (o el número si no tiene); el control cocheraNumber guarda el número -->
                            <input readonly id="cocheraNumber" [value]="{nivel: form.get('cocheraStep.cocheraLevel')?.value, numero: form.get('cocheraStep.cocheraNumber')?.value} | appCocheraNombre : consorcio.cocheras" type="text" placeholder="Número" pInputText/>
                            <div class="errorValidation" *ngIf="form.get('cocheraStep.cocheraNumber')?.invalid && (form.get('cocheraStep.cocheraNumber')?.touched || submitted)">
                                <p> Campo obligatorio</p>
                            </div>
                            <p><br></p>

                            <label>Indique si es dueño o alquila esta cochera</label>
                            <p-dropdown
                                formControlName="cocheraRole"
                                [options]="rolesCocheraOptions"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Rol de ocupación"
                                styleClass="w-full"
                                />
                            <div class="errorValidation" *ngIf="form.get('cocheraStep.cocheraRole')?.invalid && (form.get('cocheraStep.cocheraRole')?.touched || submitted)">
                                <p> Campo obligatorio</p>
                            </div>
                            <p><br></p>
                        </div>
                    }
                    @case('emailStep'){
                        <div formGroupName="emailStep" class="form-container">
                            <p class="overtitle">Contacto</p>
                            <h4> ¿Cuál es tu Email?</h4>
                            <label for="email"></label>

                            <input id="email" formControlName="email" type="text" placeholder="Email" pInputText autocomplete="email"/>
                            <div class="errorValidation" *ngIf="form.get('emailStep.email')?.invalid && (form.get('emailStep.email')?.touched || submitted)">
                                <p> Campo obligatorio</p>
                            </div>
                            <p><br></p>
                        </div>

                    }
                    @case('phoneStep'){
                        <div class="form-container" formGroupName="phoneStep">
                            <p class="overtitle">Contacto</p>
                            <label for="country">País</label>
                            <p-dropdown styleClass="w-full" placeholder="País" id="country" [options]="paises" formControlName="country" name="country">
                                <ng-template let-opt pTemplate="item">
                                    <img
                                        [src]="'https://flagsapi.com/' + opt.code + '/shiny/32.png'"
                                        width="16"
                                        height="16"
                                        [alt]="opt.name">
                                    <span> {{ opt.name }}</span>
                                </ng-template>
                                <ng-template let-opt pTemplate="selectedItem">
                                    <span>{{ opt.name }}</span>
                                </ng-template>
                            </p-dropdown>
                            <div class="errorValidation" *ngIf="form.get('phoneStep.country')?.invalid && (form.get('phoneStep.country')?.touched || submitted)">
                                <p> Campo obligatorio</p>
                            </div>
                            <p><br></p>
                            <h4> ¿Cuál es tu número de teléfono?</h4>
                            <div class="inline-inputs center">
                                <div class="flex align-items-center gap-2">
                                    <div class="phoneExtra">+</div>
                                    @if(form.value.phoneStep.country) {
                                        <p>{{+form.value.phoneStep.country.phoneCode}}</p>
                                    }
                                </div>
                                <input maxlength="5" id="phoneArea" autocomplete="tel-area-code" formControlName="phoneArea" type="number" placeholder="Ej: 341" pInputText/>
                                <div class="flex align-items-center gap-2">
                                    <div class="phoneExtra">15</div>
                                    <input id="phoneNumber" autocomplete="tel-local" maxlength="8" formControlName="phoneNumber" type="text" placeholder="Ej: 64861231" pInputText/>
                                </div>
                            </div>
                            <p><b>IMPORTANTE: si no está bien escrito no podrás interactuar con la administración. Por favor escríbelo atentamente.</b></p>
                        </div>
                    }
                    @case('replaceStep'){
                        @if (form.get('typeStep.consorcistaType').value == 'owner') {
                            <div class=" form-container" formGroupName="stepReplace">
                                <p class="overtitle">Mudanzas</p>
                                <h4>¿Adquirió usted este inmueble recientemente?</h4>
                                <p-dropdown formControlName="isReplacing"
                                    [options]="replaceOptions[form.get('typeStep.consorcistaType').value]"
                                    placeholder="Seleccione una opción"
                                    styleClass="w-full"
                                    optionLabel="label"
                                    optionValue="value">
                                </p-dropdown>
                                <p><br> <b>ATENCIÓN:</b> la primera opción le dirá al administrador que hay nuevos propietarios y que debe reemplazar datos de contacto.</p>
                            </div>
                        }@else if (form.get('typeStep.consorcistaType').value == 'tenant') {
                            <div class=" form-container" formGroupName="stepReplace">
                                <p class="overtitle">Mudanzas</p>
                                <h4> ¿Hubo una mudanza?</h4>
                                <p-dropdown formControlName="isReplacing"
                                    [options]="replaceOptions[form.get('typeStep.consorcistaType').value]"
                                    placeholder="Seleccione una opción"
                                    styleClass="w-full"
                                    optionLabel="label"
                                    optionValue="value">
                                </p-dropdown>
                            </div>
                        }
                    }
                    @case('addConsorcistaStep'){
                        <div class="form-container" formGroupName="addConsorcistaStep">
                            <p class="overtitle">Añadir Consorcista</p>
                            <h4>Ingresá los datos del consorcista que se va a mudar</h4>
                            <p><br></p>
                            <label for="newConsorcistaFirstName">Nombre</label>
                            <!-- valor inventado de autocomplete para que google no moleste -->
                            <input autocomplete="newConsorcistaFirstName" id="newConsorcistaFirstName" formControlName="newConsorcistaFirstName" type="text" placeholder="Nombre" pInputText/>
                            <p><br></p>
                            <label for="newConsorcistaLastName">Apellido</label>
                            <input  autocomplete="newConsorcistaFirstName" id="newConsorcistaLastName" formControlName="newConsorcistaLastName" type="text" placeholder="Apellido" pInputText/>

                            <p><br></p>
                            <p class="label">Teléfono</p>
                            <div class="inline-inputs form-container ">
                                <div class="flex align-items-center gap-2">
                                    <div class="phoneExtra">+</div>
                                    @if(form.value.phoneStep.country) {
                                        <p>{{+form.value.phoneStep.country.phoneCode}}</p>
                                    }
                                </div>
                                <input id="phoneArea" maxlength="5"  autocomplete="newConsorcistaFirstName" formControlName="newConsorcistaPhoneArea" type="number" placeholder="Ej: 341" pInputText/>
                                <div class="flex align-items-center gap-2">
                                    <div class="phoneExtra">15</div>
                                    <input id="phoneNumber" maxlength="8"  autocomplete="newConsorcistaFirstName" formControlName="newConsorcistaPhoneNumber" type="text" placeholder="Ej: 64861231" pInputText/>
                                </div>
                            </div>
                            <p><br></p>
                            @if(consorcio && consorcio.cocheras){
                                <p><br></p>
                                 <h4>Agregar/modificar cochera</h4>
                                 <p><br></p>
                                 <button type="button"  class="button-primary-2" aria-label="Agregar/modificar cochera" (click)="showAddCocheraDialog=true; form.get('addConsorcistaStep.newConsorcistahasGarage')?.setValue(true);">
                                    +
                                </button>
                                <p><br></p>
                                @if (form.get('addConsorcistaStep.newConsorcistahasGarage')?.value) {
                                    <div style="padding: 1rem; background-color: rgb(212, 212, 212); border-radius: 10px; margin-top: 1rem;">
                                        <h5>Seleccionada:</h5>
                                        <p *ngIf="consorcio.garageLevels ?? true">Nivel: {{form.get('addConsorcistaStep.newConsorcistaCochera.nivel')?.value}}</p>
                                        <p>Cochera: {{ {nivel: form.get('addConsorcistaStep.newConsorcistaCochera.nivel')?.value, numero: form.get('addConsorcistaStep.newConsorcistaCochera.numero')?.value} | appCocheraNombre : consorcio.cocheras }}</p>
                                        <div style="text-align: left;" formGroupName="newConsorcistaCochera">
                                            <p><br></p>
                                            <label>¿Dueño o Inquilino?</label>
                                            <p-dropdown
                                                formControlName="occupancyRole"
                                                [options]="rolesCocheraOptions"
                                                optionLabel="label"
                                                optionValue="value"
                                                placeholder="Rol de ocupación"
                                                styleClass="w-full"
                                                />
                                        </div>  
                                            <button type="button"  class="button-danger" aria-label="Quitar cochera" (click)="form.get('addConsorcistaStep.newConsorcistahasGarage')?.setValue(false);">
                                        X
                                    </button>
                                    </div>
                                }
                                <p-dialog
                                [(visible)]="showAddCocheraDialog"
                                [modal]="true"
                                [style]="{ width: '100%' }"
                                header="Agregar Cochera"
                                styleClass="dialog2"
                                >
                                <app-cocheras-view *ngIf="consorcio.cocheras" [tieneNiveles]="consorcio.garageLevels??true" [cocheras]="consorcio.cocheras" (onSelect)="pickedCochera($event)"  [(selectedNivel)]="selectedNivel" [(selectedNumero)]="selectedNumero" ></app-cocheras-view>
                        </p-dialog>
                            }
                                <p><br></p>


                        </div>
                    }
                    @case ('listConsorcistaStep') {
                        <p class="overtitle">Lista de Consorcistas para la Mudanza</p>
                        <h4>Revisá los datos de los consorcistas que se van a mudar</h4>
                        @for(consorcista of consorcistasToTransfer; track consorcio$){
                            <div class="flex flex-wrap align-items-end gap-2">
                                Nombre: {{consorcista.firstName}} {{consorcista.lastName}} - Email: {{consorcista.email}} - Numero de Whatsapp : {{consorcista.countryCode}} {{consorcista.phoneArea}} {{consorcista.phoneNumber}}
                            </div>

                        }

                    }
                     @case('queryStep'){
                        <!-- Paso nuevo, opcional, antes de confirmar el registro (alta directa o mudanza). 'repair' y 'complain'
                        son dos opciones distintas para el consorcista pero generan el mismo tipo de interacción (Complain) al
                        aceptar el registro/mudanza; ver mapeo en el .ts (case 'queryStep'). -->
                        <div formGroupName="queryStep" class="form-container">
                            <p class="overtitle">Antes de terminar</p>
                            <h4>¿Querés dejarnos algo antes de terminar? (opcional)</h4>
                            <p><br></p>
                            <div class="radio-square">
                                <input id="interactionQuestion" class="input-number" name="interactionType" [value]="'question'" formControlName="interactionType" type="radio">
                                <label for="interactionQuestion"> Pedir información </label>
                                <input id="interactionRepair" class="input-number" name="interactionType" [value]="'repair'" formControlName="interactionType" type="radio">
                                <label for="interactionRepair"> Solicitar un arreglo </label>
                                <input id="interactionComplain" class="input-number" name="interactionType" [value]="'complain'" formControlName="interactionType" type="radio">
                                <label for="interactionComplain"> Hacer un reclamo </label>
                            </div>
                            <p><br></p>
                            <label for="interactionText">Contanos brevemente de qué se trata</label>
                            <textarea id="interactionText" formControlName="interactionText" rows="4" placeholder="Escribí acá tu consulta o reclamo (opcional)" pInputTextarea></textarea>
                            <p><br></p>
                        </div>
                    }
                    @case ('dataListStep') {
                        <div class="form-container">
                            <p class="overtitle">Confirma tus Datos</p>
                            <h4>Revisá los datos</h4>
                            <div class="review-data">
                                <p><b>Nombre:</b> {{form.get('nameStep.firstName')?.value}} {{form.get('nameStep.lastName')?.value}}</p>
                                <p><b>Rol:</b> {{_t('roles.' + form.get('typeStep.consorcistaType')?.value)}}</p>
                                @if(form.get('typeStep.consorcistaType')?.value == 'realEstate'){
                                    <p><b>Inmobiliaria:</b> {{form.get('stepRealEstate.realEstateName')?.value}}</p>
                                }
                                @if (!form.get('unitStep.onlyGarage').value) {
                                    <p *ngIf="consorcio.hasTowers"><b>Torre:</b> {{form.get('unitStep.tower')?.value}}</p>
                                    <p><b>Unidad:</b> {{form.get('unitStep.unit')?.value}}</p>
                                    <p><b>Piso:</b> {{form.get('unitStep.floor')?.value}}</p>
                                }
                                <p><b>Email:</b> {{form.get('emailStep.email')?.value}}</p>
                                <p><b>Teléfono:</b> {{form.get('phoneStep.countryCode')?.value}} {{form.get('phoneStep.phoneArea')?.value}} {{form.get('phoneStep.phoneNumber')?.value}}</p>
                                <p *ngIf="form.get('cocheraStep.cocheraLevel')?.value"><b>Cochera:</b> {{form.get('cocheraStep.cocheraLevel')?.value}} - {{ {nivel: form.get('cocheraStep.cocheraLevel')?.value, numero: form.get('cocheraStep.cocheraNumber')?.value} | appCocheraNombre : consorcio.cocheras }}</p>
                            </div>
                        </div>
                    }
                }
                <p><br><br></p>
                <div class="btn-cont">
                   

                        @if(stepsTaken >1)
                        {
                            <button type="button" pButton
                                        pRipple
                                        (click)="goStepBack()"
                                        [label]="'Volver'"
                                        class="w-full p-3 text-xl"
                                        ></button>
                        }
                         @if(actualStep == 'listConsorcistaStep'){
                         <button type="button" pButton
                                        pRipple
                                        (click)="nextStep('addConsorcistaStep')"
                                        [label]="'Añadir Consorcista'"
                                        class="w-full p-3 text-xl"
                                        ></button>

                    }
                    <div class="w-full flex flex-column align-items-center">
                        <button type="submit" pButton pRipple
                        [label]="(actualStep=='last' || actualStep=='queryStep') ? 'Terminar Registro' :'Continuar' "
                        class="w-full p-3 text-xl button-primary"></button>
                        @if(actualStep=='welcomeStep'){
                            <p class="text-sm text-center mt-2">Al finalizar podrás dejar una consulta o pedido para el administrador</p>
                        }
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>
<p-dialog header="ERROR" [visible]="errorMessage && errorMessage.severity == 'error'" [modal]="true" [closable]="false" [dismissableMask]="false">
    <p>{{errorMessage?.detail}}</p>
    <p><br><br></p>
    <button type="button" pButton pRipple
            (click)="(errorMessage?.action) ? errorMessage.action() : null;errorMessage = {}"
            [label]="'Aceptar'"
            class="w-full p-3 text-xl button-primary"></button>
</p-dialog>
<p-dialog header="ÉXITO" [visible]="showFinishDialog" [modal]="true" [closable]="false" [dismissableMask]="false">
    <h2>¡Gracias por tu registro!</h2>
    <h4>El formulario se ha enviado correctamente. </h4>
    <p>Recibimos tu formulario correctamente. En las próximas 24 a 48 horas hábiles la administración va a revisar tus datos y te va a confirmar el alta en el consorcio.</p>
    <p><br><br></p>
    <p><strong>Ya podés volver a WhatsApp — no hace falta que hagas nada más acá.</strong></p>
    <p><br><br></p>
    <!-- <button type="button" pButton pRipple
            (click)="showFinishDialog = false; router.navigate(['/'])"
            [label]="'Aceptar'"
            class="w-full p-3 text-xl button-primary"></button> -->
</p-dialog>
<p-confirmDialog [style]="{ width: '30vw' }"></p-confirmDialog>